import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './detalleProducto.css';
import './menuFlotante.css';
import './productFilter.css';
import { CartProvider } from './contexts/CartContext';
import { AddressProvider } from './contexts/AddressContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FormProvider } from './contexts/FormContext';
import { Provider } from 'react-redux';
import { store } from './store/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <CartProvider>
      <AddressProvider>
        <FormProvider>
          <App />
        </FormProvider>
      </AddressProvider>
    </CartProvider>
    </Provider>
  </React.StrictMode>
);